define(function() {
    return function getPropertyCaseInsensitive(obj, property) {
        property = (property + "").toLowerCase();
        for (var p in obj) {
            if (obj.hasOwnProperty(p) && property === (p + "").toLowerCase()) {
                return obj[p];
            }
        }
    };
});